export const IDCTA_INIT_RENDER = 'IDCTA_INIT_RENDER';
export const IDCTA_FAIL_RENDER = 'IDCTA_FAIL_RENDER';
export const SHOW_FAVOURITES_TOOLTIP = 'SHOW_FAVOURITES_TOOLTIP';
export const SHOW_RATINGS_TOOLTIP = 'SHOW_RATINGS_TOOLTIP';
export const HIDE_IDCTA_TOOLTIP = 'HIDE_IDCTA_TOOLTIP';
export const IDCTA_FLAGPOLE_RED = 'IDCTA_FLAGPOLE_RED';
